// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"criteria-summary_wrapper__tpFQY","title":"criteria-summary_title__OtKZO"};